import * as React from 'react';

import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';
import { Icon, ICON_NAME } from 'components/icon';
import { FR_FRIEND_LIST_TEXT_KEYS } from '../fr-friend-list-common';
import './fr-friend-list-feedback.styles.less';
import { getModeClass } from 'utils/css';

export class FRFriendListFeedback extends React.Component<IFRFriendListFeedbackProps> {
    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, shouldInheritStyles } = this.props;
        const title: string = this.props.error
            ? translateKey(FR_FRIEND_LIST_TEXT_KEYS.FEEDBACK_ERROR_TITLE)
            : translateKey(FR_FRIEND_LIST_TEXT_KEYS.FEEDBACK_SUCCESS_TITLE);
        const content: string = this.props.error
            ? translateKey(FR_FRIEND_LIST_TEXT_KEYS.FEEDBACK_ERROR_CONTENT)
            : translateKey(FR_FRIEND_LIST_TEXT_KEYS.FEEDBACK_SUCCESS_CONTENT);
        const basePageStyleClass = getModeClass('sitegen-fr-friend-list', shouldInheritStyles);
        const feedbackStyleClass = getModeClass('sitegen-fr-friend-list-feedback', shouldInheritStyles);

        return (
            <div className={`${basePageStyleClass} ${feedbackStyleClass}`}>
                <div className={`${feedbackStyleClass}__container`}>
                    <div className={`${feedbackStyleClass}__header`}>
                        <div className={`${feedbackStyleClass}__title`}>
                            {title}
                        </div>

                        <Icon name={ICON_NAME.CLOSE} onClick={this.props.onClose} />
                    </div>

                    <div className={`${feedbackStyleClass}__content`}>
                        {content}
                    </div>

                    <div className={`${feedbackStyleClass}__action-button`} onClick={this.props.onClose}>
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.CLOSE)}
                    </div>
                </div>
            </div>
        );
    }
}

export interface IFRFriendListFeedbackProps extends ITranslationProps {
    readonly error: Error | null;
    readonly onClose: () => void;
    readonly shouldInheritStyles: boolean;
}

export const FRFriendListFeedbackWithTranslations = translate()(FRFriendListFeedback);
